import { render, staticRenderFns } from "./rightQrcode.vue?vue&type=template&id=b4484bf8&scoped=true&"
import script from "./rightQrcode.vue?vue&type=script&lang=js&"
export * from "./rightQrcode.vue?vue&type=script&lang=js&"
import style0 from "./rightQrcode.vue?vue&type=style&index=0&id=b4484bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4484bf8",
  null
  
)

export default component.exports